export const ERROR_TEXT_REUSE_EMAIL =
  'This email is already used. Try another one.';

export const HEADER_ATTENTION = 'Attention';

export const DEFAULT_MANAGER_NOTIFICATION = ['MANAGER_RFQ_CREATED'];

export const DEFAULT_CUSTOMER_NOTIFICATION = [
  'CUSTOMER_PO_READY_FOR_SHIP',
  'CUSTOMER_PO_RECEIVING_COMPLETE',
  'CUSTOMER_PO_DONE',
];
